import React, { useState, forwardRef, useEffect } from "react";

import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import studentsAPI from "../../../../services/students";
import uiDataAPI from "../../../../services/ui_data";
import { Dropdown } from "primereact/dropdown";

const UpdateRegistrationPreviousResultModal = forwardRef((props, ref) => {
  const accessToken = "";
  const [registrationPreviousResult, setRegistrationPreviousResult] = useState(props?.student?.previous_result);
  useEffect(() => {
    setRegistrationPreviousResult(props?.student?.previous_result);
  }, [props]);
  //
  const UiDataStudentResultTypesListQuery = uiDataAPI.UiDataStudentResultTypesList(
    accessToken
  );
  //
  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Modifier le dernier résultat"
        serviceAPI={studentsAPI}
        id={props?.student?.id}
        schoolId={props?.schoolId}
        trainingId={props?.trainingId}
        data={{
          previous_result: registrationPreviousResult,
        }}
      >
        <Dropdown
          //value={registrationPreviousResult}
          value={UiDataStudentResultTypesListQuery?.data?.data?.find(
            (obj) => obj.id === registrationPreviousResult
          )}
          options={UiDataStudentResultTypesListQuery?.data?.data}
          onChange={(e) => setRegistrationPreviousResult(e.value?.id)}
          optionLabel="name"
          placeholder="Sélectionner un résultat"
          checkmark={true}
        />
      </MeaUpdateModal>
    </>
  );
});

export default UpdateRegistrationPreviousResultModal;
